    <div class="card">
        <div class="card-body d-flex flex-wrap">
            <div class="col-12 user-container"
                [ngClass]="{ 'col-md-6' : (profileData?.partner !== undefined) }"
            >
                <div HJSuppress class="header-details d-flex">
                    <app-user-badge [username]="profileData?.username">
                    </app-user-badge>
                    <div class="header-basic-details">
                        <span class="user-name">{{profileData?.username}}</span>
                    </div>
                </div>
                <div class="user-data">{{'myProfile.userData' | translate}}</div>
                <div class="user-data-item">
                    <span class="user-data-item-label">{{'myProfile.email' | translate}}</span>
                    <span class="user-data-item-value text-ellipsis" textEllipsisToTooltip ngbTooltip=""  HJSuppress>
                        {{profileData?.email | replaceIfNull}}
                    </span>
                </div>
                <div class="user-data-item">
                    <span class="user-data-item-label">{{'myProfile.phone' | translate}}</span>
                    <span HJSuppress class="user-data-item-value">{{profileData?.phone | replaceIfNull}}</span>
                </div>
                <div class="user-data-item" *ngIf="!profileData?.isUserOnExternalProvider">
                    <span class="user-data-item-label">{{'myProfile.password' | translate}}</span>
                    <span class="user-data-item-value action-link" (click)="navigateToChangePasswordHandler()">
                        {{'myProfile.changePassword' | translate}}
                    </span>
                </div>
            </div>
            <div class="col-12 col-md-6 partner-container" *ngIf="profileData?.partner !== undefined">
                <div class="profile-picture-spacer header-details d-none d-md-block"></div>
                <div class="user-data">{{'myProfile.partnerData' | translate}}</div>
                <div class="user-data-item">
                    <span class="user-data-item-label">{{'myProfile.name' | translate}}</span>
                    <span HJSuppress class="user-data-item-value">{{profileData?.partner?.name | replaceIfNull}}</span>
                </div>
                <div class="user-data-item">
                    <span class="user-data-item-label">{{'myProfile.email' | translate}}</span>
                    <span class="user-data-item-value text-ellipsis" textEllipsisToTooltip ngbTooltip=""  HJSuppress>
                        {{profileData?.partner?.email | replaceIfNull}}
                    </span>
                </div>
                <div class="user-data-item">
                    <span class="user-data-item-label">{{'myProfile.uniqueIdentifier' | translate}}</span>
                    <span HJSuppress class="user-data-item-value">{{profileData?.partner?.uniqueIdentifier | replaceIfNull}}</span>
                </div>
                <div class="user-data-item">
                    <span class="user-data-item-label">{{'myProfile.phone' | translate}}</span>
                    <span HJSuppress class="user-data-item-value">{{profileData?.partner?.phone | replaceIfNull}}</span>
                </div>
            </div>
        </div>
    </div>
    <span class="contract-modifications-label d-flex mt-3" *ngIf="profileData?.partner !== null && !readOnly">
        <ng-container *ngIf="allowClientDataRequest; else noClientDataRequestPermission">
            {{'myProfile.clientDataModificationsLabel1' | translate}}&nbsp;
            <span class="action-link" (click)="redirectClientDataRequestHandler()">
            {{'myProfile.clientDataModificationsLabel2' | translate}}
            </span>
        </ng-container>
        <ng-template #noClientDataRequestPermission>
            <span [innerHTML]="'myProfile.clientDataModificationsLabel' | translate"></span>
        </ng-template>
    </span>
